<template>
  <single-route />
</template>

<script>
import SingleRoute from "@/components/3pl/Settings/RoutesAndVehicles/Routes/TerminalToTerminal/EditRoute/index";
export default {
  components: {
    SingleRoute,
  },
};
</script>

<style></style>
